import { render, staticRenderFns } from "./payment-main.vue?vue&type=template&id=1a6dd0f2&scoped=true&"
import script from "./payment-main.vue?vue&type=script&lang=js&"
export * from "./payment-main.vue?vue&type=script&lang=js&"
import style0 from "./payment-main.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./payment-main.vue?vue&type=style&index=1&id=1a6dd0f2&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1a6dd0f2",
  null
  
)

export default component.exports